import React from 'react';
import LockTwoToneIcon from '@mui/icons-material/LockTwoTone';
import {Box, Button} from '@mui/material';

function NoAutorizado() {
	return (
		<Box
			display="flex"
			flexDirection="column"
			alignItems="center"
			justifyContent="center"
			textAlign="center"
			marginTop={8}
			marginRight={8}
			marginBottom={8}
			marginLeft={8}
			data-testid="no-autorizado"
		>
			<h1>
				No Autorizado
			</h1>
			<p>Usted no está autorizado para esta acción</p>
			<LockTwoToneIcon />
			<Button
				type="submit"
				variant="contained"
				sx={{
					py: '0.8rem',
					mt: 2,
					width: '80%',
					maxWidth: '300px',
					marginInline: 'auto',
				}}
				data-testid="boton-regresar"
				onClick={() => {
					window.history.back();
				}}
			>
          Regresar
			</Button>
		</Box>
	);
}

export default NoAutorizado;
